module.exports = __webpack_public_path__ + "static/1_1_defineai_LT-872dd9cae93abfee130881b2a064bec9.svg";